// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.theme_sec p{
    font-family: "sofia pro", sans-serif;
    font-size: 46px;
    text-align: center;
    font-weight: 700;
    color: #000;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/career.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;IACpC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf","sourcesContent":["\n.theme_sec p{\n    font-family: \"sofia pro\", sans-serif;\n    font-size: 46px;\n    text-align: center;\n    font-weight: 700;\n    color: #000;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
